
/* Maresia - Collection Metal Swatches */

document.addEventListener("click", function (event) {
  const button = event.target.closest(".maresia-swatch-select");
  if (!button) return;

  console.log("Maresia swatch click detected");

  event.preventDefault();
  event.stopPropagation();

  const card = button.closest(".product-item");
  const swatch = button.closest("[data-swatch-button]");

  if (!card || !swatch) {
    console.log("Maresia: card or swatch not found");
    return;
  }

  // Get selected metal name
  const metal =
    swatch.dataset.tooltip ||
    button.dataset.metalName ||
    button.querySelector("[data-swatch-text]")?.textContent.trim();

  // Update metal label
  const label = card.querySelector("[data-metal-label]");

  if (label && metal) {
    label.textContent = metal;
    console.log("Metal label updated:", metal);
  } else {
    console.log("Metal label not found");
  }

  // Highlight selected swatch
  card.querySelectorAll("[data-swatch-button]").forEach(item => {
    item.classList.remove("maresia-selected");
  });

  swatch.classList.add("maresia-selected");

  // Find selected variant image
  const variantTitle = swatch.dataset.swatchVariantName;

  const images = card.querySelectorAll(
    ".product-item__bg__inner[data-variant-title]"
  );

  console.log("Variant:", variantTitle);
  console.log("Available images:", images.length);

  if (!variantTitle || !images.length) return;

  const matchingImage = Array.from(images).find(image =>
    image.dataset.variantTitle === variantTitle
  );

  if (!matchingImage) {
    console.log("Matching variant image not found");
    return;
  }

  // Switch product image
  images.forEach(image => {
    image.classList.remove("is-visible");
  });

  matchingImage.classList.add("is-visible");

  console.log("Maresia image switched successfully");
});
